/* eslint-disable import/prefer-default-export */
export const cardLinkFormValuesSelector = (state) => state.forms.card_link
